import React from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { tokens } from '@/locales/translations/tokens';

interface CardNavigationProps {
  currentIndex: number;
  totalCards: number;
  isLoading: boolean;
  onPrevious: () => void;
  onNext: () => void;
}

export const CardNavigation: React.FC<CardNavigationProps> = ({
  currentIndex,
  totalCards,
  isLoading,
  onPrevious,
  onNext
}) => {
  const { t } = useTranslation();

  return (
    <div className='absolute bottom-0 left-0 right-0 flex items-center justify-between border-t border-border bg-card px-8 py-3.5'>
      <button
        onClick={onPrevious}
        className='group flex items-center gap-2 text-sm font-medium text-muted-foreground transition-colors hover:text-primary disabled:pointer-events-none disabled:opacity-40'
        disabled={isLoading}
      >
        <ChevronLeft
          size={18}
          strokeWidth={2.5}
          className='text-primary transition-transform group-hover:-translate-x-0.5'
        />
        <span>{t(tokens.workstation.sources.previous)}</span>
      </button>

      <div className='flex items-center justify-center'>
        <motion.div
          key={currentIndex}
          initial={{ opacity: 0, y: 5 }}
          animate={{ opacity: 1, y: 0 }}
          className='flex items-center'
        >
          <span className='text-sm font-medium text-primary'>
            {currentIndex + 1}
          </span>
          <span className='mx-1.5 text-muted-foreground'>/</span>
          <span className='text-sm text-foreground'>
            {totalCards}
          </span>
        </motion.div>
      </div>

      <button
        onClick={onNext}
        className='group flex items-center gap-2 text-sm font-medium text-muted-foreground transition-colors hover:text-primary disabled:pointer-events-none disabled:opacity-40'
        disabled={isLoading}
      >
        <span>{t(tokens.workstation.sources.next)}</span>
        <ChevronRight
          size={18}
          strokeWidth={2.5}
          className='text-primary transition-transform group-hover:translate-x-0.5'
        />
      </button>
    </div>
  );
};